import { Box } from '@mui/material';
import CustomTypography from '@ui-components/Typography/CustomTypography';

const NotFound = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CustomTypography className="pb-12 mt-40" id="notfound" variant="h1">
        404 - Page Not Found
      </CustomTypography>
    </Box>
  );
};

export default NotFound;
